import { useMemo } from 'react';
import { type VehicleCycledEnergyRecord } from '../services/battery-monitoring-api/types/battery-monitoring-api';

export type ChassisNumberVehicle = Pick<VehicleCycledEnergyRecord, 'chassisNumber' | 'customer' | 'customerCountry'>;

interface UseChassisNumbersProperties {
  vehicles?: ChassisNumberVehicle[];
  selectedCountries: string[];
  selectedCustomers: string[];
}

const useChassisNumbers = ({
  vehicles,
  selectedCountries,
  selectedCustomers,
}: UseChassisNumbersProperties): string[] => {
  return useMemo(() => {
    if (!vehicles) return [];

    const unique = new Set<string>();
    const hasCountryFilter = selectedCountries.length > 0;
    const hasCustomerFilter = selectedCustomers.length > 0;

    for (const vehicle of vehicles) {
      const matchesCountry = !hasCountryFilter || selectedCountries.includes(vehicle.customerCountry);
      const matchesCustomer = !hasCustomerFilter || selectedCustomers.includes(vehicle.customer);

      if (vehicle.chassisNumber && matchesCountry && matchesCustomer) {
        unique.add(vehicle.chassisNumber);
      }
    }

    return [...unique].toSorted((a, b) => a.localeCompare(b));
  }, [selectedCountries, selectedCustomers, vehicles]);
};

export default useChassisNumbers;
